import React, { useState, useEffect } from 'react';
import './Users.css';
import usersIcon from './users.png';
import searchIcon from './search.png';
import axios from 'axios';
import AddUserPopup from './AddUserPopup';
import ImportUsersPopup from './ImportUsers';
import CircularProgress from '@mui/material/CircularProgress';

// Custom Alert Component
const CustomAlert = ({ show, message, type, onConfirm, onCancel }) => {
    if (!show) return null;

    return (
        <div className="custom-alert-overlay">
            <div className="custom-alert-box">
                <div className="custom-alert-content">
                    <h3>{type === "confirm" ? "Confirm" : "Alert"}</h3>
                    <p>{message}</p>
                    <div className="custom-alert-buttons">
                        {type === "confirm" && (
                            <button className="alert-cancel-btn" onClick={onCancel}>Cancel</button>
                        )}
                        <button className="alert-confirm-btn" onClick={onConfirm}>
                            {type === "confirm" ? "Yes" : "OK"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const Users = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isAddUserOpen, setIsAddUserOpen] = useState(false);
    const [isImportUserOpen, setIsImportUserOpen] = useState(false);
    const [selectedRole, setSelectedRole] = useState('');
    const [isEditMode, setIsEditMode] = useState(false);
    const [userToEdit, setUserToEdit] = useState(null);

    // Alert states
    const [alertConfig, setAlertConfig] = useState({
        show: false,
        message: '',
        type: 'alert', // 'alert' or 'confirm'
        onConfirm: () => {},
        onCancel: () => {}
    });

    // State to track selected role
    const edit = `${process.env.PUBLIC_URL}/users/edit.png`;
    const message = `${process.env.PUBLIC_URL}/users/Vector.png`;
    const trash = `${process.env.PUBLIC_URL}/users/delete.png`;

    const handleAddUser = (userData) => {
        // console.log('User Data Submitted:', userData);
        // Add user logic here
        // fetchAgents();
        // setIsAddUserOpen(false);
    };

    const handleEditUser = (userData) => {
        // Update the user in the local state
        setUsers(users.map(user => 
            user.userID === userData.userID ? userData : user
        ));
        
        // Close the popup and reset edit mode
        setIsAddUserOpen(false);
        setIsEditMode(false);
        setUserToEdit(null);
    };

    const openEditUserPopup = (user) => {
        setUserToEdit(user);
        setIsEditMode(true);
        setIsAddUserOpen(true);
    };

    useEffect(() => {
        const fetchAgents = async () => {
            try {
                setLoading(true);
                const user = localStorage.getItem('insuranceUser');
                const user_info = JSON.parse(user);
                const token = user_info.token;
                const orgID = sessionStorage.getItem("loggedInUser");

                const response = await axios.get('/auth/getAgents')

                const agentData = response.data;

                const usersWithType = await Promise.all(agentData.map(async (agent) => {
                    try {
                        const userTypeResponse = await axios.get(`/auth/getUserType/${agent.userID}`, {
                            headers: {
                                Authorization: `Bearer ${token}`,
                            },
                        });

                        return {
                            ...agent,
                            userType: userTypeResponse.data.userType,
                        };
                    } catch (error) {
                        console.error(`Error fetching userType for ${agent.userID}:`, error);
                        return agent;
                    }
                }));

                setUsers(usersWithType);
            } catch (error) {
                console.error('Error fetching agents:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchAgents();
    }, [isAddUserOpen]);

    const filteredUsers = users.filter((user) => {
        const matchesSearch = user.FirstName.toLowerCase().includes(searchTerm.toLowerCase()) || user.userID.toLowerCase().includes(searchTerm.toLowerCase());
        const matchesRole = selectedRole ? user.userType === selectedRole.toLowerCase() || user.userType === selectedRole : true;
        return matchesSearch && matchesRole;
    });

   const handleDeleteUser = async (userID) => {
        // Show confirmation dialog
        setAlertConfig({
            show: true,
            message: "Are you sure you want to delete this agent?",
            type: 'confirm',
            onConfirm: async () => {
                try {
                    await axios.delete(`/validOrganisation/orgAgentDelete/${userID}`);
                    // Remove the user from local state
                    setUsers(prevUsers => prevUsers.filter(user => user.userID !== userID));

                    // Show success alert
                    setAlertConfig({
                        show: true,
                        message: "Agent deleted successfully!",
                        type: 'alert',
                        onConfirm: () => setAlertConfig({ ...alertConfig, show: false })
                    });
                } catch (error) {
                    console.error("Error deleting agent:", error);

                    // Show error alert
                    setAlertConfig({
                        show: true,
                        message: "Failed to delete agent.",
                        type: 'alert',
                        onConfirm: () => setAlertConfig({ ...alertConfig, show: false })
                    });
                }
            },
            onCancel: () => setAlertConfig({ ...alertConfig, show: false })
        });
    };
    // Function to open Gmail compose page with confirmation alert
    const openMailApp = () => {
        const confirmMail = window.confirm("You want to open the email?");
        if (confirmMail) {
            window.open("https://mail.google.com/mail/?view=cm&fs=1", "_blank");
        }
    };

    return (
        <div className="user-page-container">
         <CustomAlert 
                show={alertConfig.show}
                message={alertConfig.message}
                type={alertConfig.type}
                onConfirm={alertConfig.onConfirm}
                onCancel={alertConfig.onCancel}
            />

            <div className="user-page-controls">
                <div className="user-page-header">
                    <h6>Users</h6>
                      <div style={{
              color: "#9E9E9E",
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 400,
              fontSize: "14px",
              letterSpacing: "0.15px",
              marginTop: "4px",
              borderRadius: "4px",
              width: "fit-content"
            }}>
              Additional text
            </div>
                </div>
                <div className="right-controls">
                    <button className="import-users" onClick={() => setIsImportUserOpen(true)}>
                        <img src={usersIcon} alt="users-icon" className="users-icon" />
                        <span>Import User</span>
                    </button>
                    <ImportUsersPopup open={isImportUserOpen}
                        onClose={() => setIsImportUserOpen(false)}
                        orgID={sessionStorage.getItem('loggedInUser')} />

                    <button className="add-user"onClick={() => {
                        setIsEditMode(false);
                        setUserToEdit(null);
                        setIsAddUserOpen(true);
                    }}>Add Users</button>
                    {/* <AddUserPopup
                        open={isAddUserOpen}
                        onClose={() => setIsAddUserOpen(false)}
                        onSubmit={handleAddUser}
                    /> */}
                     <AddUserPopup
                        open={isAddUserOpen}
                         className="add-user-popup"
                        onClose={() => {
                            setIsAddUserOpen(false);
                            setIsEditMode(false);
                            setUserToEdit(null);
                        }}
                        onSubmit={isEditMode ? handleEditUser : handleAddUser}
                        isEditMode={isEditMode}
                        userData={userToEdit}
                    />
                </div>
            </div>

            <div className="left-controls">
                <div className="search-container">
                    <input
                        type="text"
                        placeholder="Search ..."
                        className="search-select"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <img src={searchIcon} alt="search-icon" className="search-icon" />
                </div>
                <select
                    value={selectedRole}
                    className="role-select"
                    onChange={(e) => setSelectedRole(e.target.value)}
                >
                    <option value="">Role</option>  
                    <option value="Agent">Agent</option>
                    <option value="Executive">Executive</option>
                    <option value="Admin">Admin</option>
                </select>
            </div>

            {/* Show loader while data is being fetched */}
            {loading ? (
                <div className="loader-container">
                    <CircularProgress style={{ color: '#ff0083' }} />
                </div>
            ) : (
                <table className="user-page-table">
                    <thead>
                        <tr>
                            <th>Vet ID</th>
                            <th>Username</th>
                            <th>Role</th>
                            {/* <th>Status</th> */}
                            <th>Last active</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredUsers.map((user, index) => (
                            <tr key={index}>
                                <td>{user.userID}</td>
                                <td>{user.FirstName}</td>
                                <td>{user.userType}</td>
                                {/* <td>{user.active == 1 ? "Active" : "Inactive"}</td> */}
                                <td>{user.updatedAt}</td>
                                <td>
                                    <img
                                        src={edit}
                                        alt="Edit Icon"
                                        className="sidebar-icon"
                                        onClick={() => openEditUserPopup(user)}
                                        style={{ cursor: "pointer" }}
                                    />
                                    <img
                                        src={message}
                                        alt="Message Icon"
                                        className="sidebar-icon"
                                        onClick={openMailApp}
                                        style={{
                                            cursor: "pointer",
                                            width: "14px",  // Delete icon jitna size
                                            height: "14px",  // Delete icon jitna size
                                            filter:  "invert(10%) brightness(90%)"
                                        }}
                                    />
                                    <img
                                        src={trash}
                                        alt="Delete Icon"
                                        className="sidebar-icon"
                                        onClick={() => handleDeleteUser(user.userID)}
                                        style={{ cursor: "pointer" }}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default Users;
